module.exports = __webpack_public_path__ + "assets/img/6_599_big.df39e158.jpg";